<template>
  <el-form
    id="po-form"
    ref="purchase_order"
    label-position="top"
    :model="purchase_order"
  >
    <h1>
      Purchase order
      <el-tag
        v-show="purchase_order.mark_as_deleted == 1"
        effect="dark"
        type="danger"
      >
        DELETED
      </el-tag>
      <hr>
    </h1>
    <error-explanation :errors="errors" />
    <input
      v-show="false"
      v-model="purchase_order.id"
      type="text"
    >
    <input
      v-show="false"
      v-model="purchase_order.is_manual"
      type="text"
    >
    <el-tabs
      v-model="selected_tab"
      type="border-card"
    >
      <el-tab-pane
        label="Details"
        name="details"
      >
        <div class="row">
          <div>
            <p class="step-header">
              <span><strong>STEP 1:</strong> Generate PO</span>
              <span><strong>PO#{{ purchase_order.id }}</strong></span>
            </p>
            <div class="row-3">
              <div class="field">
                <el-form-item
                  label="Branch"
                  class="selectMob"
                  required
                  prop="branch_id"
                >
                  <el-select
                    v-model="purchase_order.branch_id"
                    style="width:100%"
                    class="selectMob"
                    filterable
                    :disabled="po_primary_disabled"
                    placeholder="Select a branch"
                    size="small"
                    @change=" get_stock();purchase_order.stock_item_branch_id = null;"
                  >
                    <el-option
                      v-for="branch in branches_list"
                      :key="branch.id"
                      :label="branch.name"
                      :value="branch.id"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <div class="field">
                <el-form-item
                  label="Supplier"
                  class="selectMob"
                  required
                  prop="supplier_id"
                >
                  <el-select
                    v-model="purchase_order.supplier_id"
                    style="width:100%;left:0!important"
                    class="selectMob"
                    filterable
                    :disabled="po_primary_disabled"
                    placeholder="Select a supplier"
                    size="small"
                    @change="
                      fill_email();
                      get_stock();
                      purchase_order.stock_item_branch_id = null;
                    "
                  >
                    <el-option
                      v-for="supplier in suppliers_list"
                      :key="supplier.id"
                      class="selectMob"
                      style="left:0!important"
                      :label="supplier.name"
                      :value="supplier.id"
                    >
                      <span
                        class="mob-view"
                        style="float: left"
                      >{{ supplier.name }}</span>
                      <span
                        class="mob-view"
                        style="float: right; color: #8492a6; font-size: 13px"
                      >{{ supplier.email }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="field">
                <el-form-item label="Send to">
                  <el-input
                    v-model="purchase_order.send_to"
                    type="text"
                    :disabled="po_primary_disabled"
                    placeholder="Enter email"
                    size="small"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="row-3">
              <div class="field product">
                <el-form-item
                  label="Account"
                  class="selectMob"
                >
                  <el-select
                    v-model="selected_accounts_id"
                    style="width: 100%"
                    class="selectMob"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Please enter a keyword"
                    :remote-method="accounts_list_query"
                    size="small"
                    :disabled="proposal != undefined && proposal.id != undefined"
                    @change="load_quotes_by_account_id(selected_accounts_id)"
                  >
                    <el-option
                      v-for="item in accounts_list"
                      :key="item.id"
                      :label="item.account_name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <div class="field product">
                <el-form-item
                  label="Quote"
                  class="selectMob"
                >
                  <el-select
                    v-model="purchase_order.proposal_id"
                    :disabled="proposal != undefined && proposal.id != undefined"
                    style="width:100%"
                    class="selectMob"
                    filterable
                    placeholder=" - Select quote - "
                    size="small"
                    @change="load_signs_by_proposal_id(purchase_order.proposal_id)"
                  >
                    <el-option
                      v-for="quote in quotes_list"
                      :key="quote.id"
                      :label="quote.value"
                      :value="quote.id"
                    >
                      <span>{{ quote.value }}</span>
                      <span style="color: #8492a6;">
                        <small>(#{{ quote.id }})</small>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="field">
                <el-form-item
                  label="Category"
                  class="selectMob"
                  prop="category_task_id"
                >
                  <el-select
                    v-model="purchase_order.category_task_id"
                    style="width:100%"
                    class="selectMob"
                    filterable
                    :disabled="po_primary_disabled"
                    placeholder="Select a Category"
                    size="small"
                  >
                    <el-option
                      v-for="category in category_tasks_list"
                      :key="category.id"
                      :label="category.name"
                      :value="category.id"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="row-2">
              <div class="field product sign">
                <el-form-item
                  label="Sign"
                  class="selectMob"
                >
                  <el-select
                    v-model="purchase_order.sign_id"
                    style="width:100%"
                    class="selectMob"
                    filterable
                    :disabled="po_primary_disabled"
                    placeholder="Select"
                    size="small"
                  >
                    <el-option
                      v-for="sign in signs_list"
                      :key="sign.id"
                      :label="sign.name"
                      :value="sign.id"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <div class="field product">
                <reimbursement-crm-user
                  v-if="purchase_order.id > 0"
                  :purchase_order_id="purchase_order.id"
                  @hook:mounted="set_default_input"
                />
              </div>
            </div>
            <div class="field space-textarea">
              <el-form-item label="Description [displayed in PO PDF]">
                <el-input
                  v-model="purchase_order.description"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 3 }"
                  :disabled="po_primary_disabled"
                  placeholder="Enter description here ... "
                  size="small"
                />
              </el-form-item>
            </div>
          </div>
          <p class="space-headline">
            <strong>Set budget</strong>
          </p>
          <div class="row-3">
            <div class="field product">
              <el-form-item
                label="Estimated $"
                required
                prop="estimated_value"
              >
                <el-input
                  v-model.number="purchase_order.estimated_value"
                  type="number"
                  :disabled="po_primary_disabled"
                  size="small"
                  @change="update_actual_value"
                />
              </el-form-item>
            </div>
            <div class="field">
              <div v-show="purchase_order.is_open_quote">
                <el-form-item
                  label="Percent applied (Charge PO)"
                  required
                  prop="charge_percent_applied"
                >
                  <el-input
                    v-model.number="purchase_order.charge_percent_applied"
                    type="number"
                    style="width: 100px"
                    size="mini"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="field">
              <div v-show="purchase_order.is_open_quote">
                <el-form-item label="Total Budget: ">
                  {{ charge_po_sale_price }}
                </el-form-item>
              </div>
            </div>
            <div style="margin-top:22px;">
              <el-button
                v-show="purchase_order.mark_as_deleted != 1"
                ref="save_btn"
                type="primary"
                class="btn"
                size="mini"
                @click.prevent="submit_form"
              >
                GENERATE PO NUMBER
              </el-button>
            </div>
          </div>
          <hr class="space-headline">
          <p class="step-header">
            <span><strong>STEP 2:</strong> Adding Items to Budget</span>
          </p>
          <div class="row-3">
            <div class="field">
              <el-checkbox
                v-model="purchase_order.is_open_quote"
                label="Charge PO (Subcontractor)"
                :disabled="purchase_order.po_status_id > 1 || is_charge_po == true"
                @change="clear_product_inputs"
              />
            </div>
            <a
              href="/stock_items"
              target="_blank"
            >
              Add PRODUCT LIST
            </a>
          </div>
          <br>
          <div class="row-3 ">
            <div class="field">
              <el-form-item
                label="Contact"
                prop="contact_name"
              >
                <el-input
                  v-model="purchase_order.contact_name"
                  label="Contact"
                  :readonly="true"
                  size="mini"
                />
              </el-form-item>
            </div>
            <div class="field">
              <el-form-item
                label="Date"
                prop="created_at"
              >
                <el-input
                  v-model="purchase_order.created_at"
                  :readonly="true"
                  size="mini"
                />
              </el-form-item>
            </div>
            <div class="field">
              <el-form-item
                label="Order Number"
              >
                <el-input
                  v-model="purchase_order.id"
                  :readonly="true"
                  size="mini"
                />
              </el-form-item>
            </div>
          </div>
          <div
            v-show="purchase_order.is_open_quote == false"
            v-if="po_id > 0"
            class="product"
          >
            <po-stock-items
              ref="ref_po_stock_items"
              :supplier_id="purchase_order.supplier_id"
              :category_supplier_id="purchase_order.category_supplier_id"
              :branch_id="purchase_order.branch_id"
              :purchase_order="purchase_order"
              :po_id="po_id"
              :po_primary_disabled="po_primary_disabled"
              @estimated_value_from_child="handle_estimated_value"
            />
          </div>
          <div class="status-line">
            <el-button
              type="primary"
              target="_blank"
              size="small"
              @click="open_pdf"
            >
              <i class="el-icon-document" />
              Print PDF
            </el-button>

            <div class="field">
              <el-select
                ref="po_status_id"
                v-model="purchase_order.po_status_id"
                class="selectMob"
                style="vertical-align: top"
                filterable
                size="small"
                @change="submit_form"
              >
                <el-option
                  v-for="status in po_status_list"
                  :key="status.id"
                  :label="status.name"
                  :value="status.id"
                />
              </el-select>
            </div>
          </div>
        </div>

        <div class="divContainer row">
          <div class="col s5">
            <proposal-specs :proposal_id="purchase_order.proposal_id" />
            <!--<sign-cuttings :cuttings="purchase_order.cuttings" ></sign-cuttings>-->
          </div>
          <div class="col m6">
            <div class="field">
              <div v-show="po_transactions.length > 0">
                <b>Transactions</b>
                <hr>
                <table class="tableclass">
                  <thead>
                    <tr>
                      <td>Status</td>
                      <td>Updated on</td>
                      <td>By</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="trans in po_transactions"
                      :key="trans.id"
                    >
                      <td>{{ trans.po_status }}</td>
                      <td>
                        <el-date-picker
                          v-if="trans.po_status == 'APPROVED'"
                          v-model="po_approved_date"
                          size="small"
                          type="date"
                          format="dd MMM yyyy"
                          class="input-with-select"
                          @change="update_po_approved_date"
                        >
                          <el-button
                            slot="append"
                            icon="el-icon-search"
                          />
                        </el-date-picker>
                        <el-date-picker
                          v-else-if="trans.po_status == 'RECEIVED'"
                          v-model="po_received_date"
                          size="small"
                          type="date"
                          format="dd MMM yyyy"
                          class="input-with-select"
                          @change="update_po_received_date"
                        >
                          <el-button
                            slot="append"
                            icon="el-icon-search"
                          />
                        </el-date-picker>
                        <span v-else>{{ trans.created_at }}</span>
                      </td>
                      <td>{{ trans.crm_user }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br>
            <stock-item-list-groups
              v-if="stock_item_id"
              :stock_item_id="stock_item_id"
            />
          </div>
        </div>
        <br>
        <div
          v-show="purchase_order.po_status_id > 1"
          class="divContainer row"
        >
          <div class="col s5">
            <b>Attachments</b>
            <hr>

            <AttachmentSection
              :title="'Invoices'"
              :allow-upload="true"
              :path="`PurchaseOrders/${purchase_order.id}/Invoices`"
            />

            <AttachmentSection
              :title="'Packing Slips'"
              :allow-upload="true"
              :path="`PurchaseOrders/${purchase_order.id}/PackingSlips`"
            />
          </div>
          <div class="col s6">
            <b>Review</b>
            <hr>
            <div class="field">
              <p>
                <label>Actual value</label>
              </p>
              <el-input
                v-model="purchase_order.actual_value"
                type="text"
                style="width:150px"
                size="small"
              />
            </div>
            <div class="field">
              <el-form-item label="Additional Info">
                <el-input
                  v-model="purchase_order.additional_info"
                  type="textarea"
                  :autosize="{ minRows: 10, maxRows: 10 }"
                  placeholder="Enter additional information here ... "
                  size="small"
                />
              </el-form-item>
            </div>
            <br>
            <br>
            <b>Supplier details</b>
            <hr>
            <div class="field">
              <el-form-item label="Invoice #">
                <el-input
                  v-model="purchase_order.supplier_invoice_no"
                  type="text"
                  placeholder="Enter supplier invoice here"
                  size="small"
                />
              </el-form-item>
            </div>
            <div class="field">
              <el-form-item label="Invoice date">
                <el-date-picker
                  v-model="purchase_order.supplier_invoice_date"
                  size="small"
                  type="date"
                  format="dd MMM yyyy"
                  value-format="yyyy-MM-dd"
                  class="input-with-select"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                  />
                </el-date-picker>
              </el-form-item>
            </div>

            <div v-show="convertable_to_stock">
              <a href="/convert_po_to_stock/">Convert to stock item</a>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="mail_count"
        name="mails"
      >
        <div v-if="message_references.length == 0">
          No emails attached.
        </div>
        <FilteredEmails
          v-if="message_references.length > 0"
          :filtered_msg_id="message_references"
          :po_id="po_id"
        />
      </el-tab-pane>
    </el-tabs>

    <div class="row">
      <hr>
      <div class="col m12">
        <a
          v-show="is_charge_po != true"
          href="/purchase_orders"
          class="btn"
        >BACK</a>
        <div class="right">
          <el-button
            v-show="purchase_order.mark_as_deleted != 1"
            ref="save_btn"
            type="primary"
            class="btn"
            size="mini"
            @click.prevent="submit_form"
          >
            SAVE
          </el-button>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
import ErrorExplanation from '../shared/ErrorExplanation';
import FilteredEmails from 'components/mailbox/FilteredEmails.vue';
import AttachmentSection from 'components/shared/AttachmentSection.vue';
import ReimbursementCrmUser from './ReimbursementCrmUser';
import PoStockItems from './PoStockItems.vue';
import ProposalSpecs from './ProposalSpecs.vue';
import StockItemListGroups from '../stock_items/StockItemListGroups.vue';

export default {
  name: 'PoEdit',
  components: {
    'error-explanation': ErrorExplanation,
    'proposal-specs': ProposalSpecs,
    FilteredEmails,
    AttachmentSection,
    ReimbursementCrmUser,
    PoStockItems,
    StockItemListGroups
  },
  props: {
    po_id: {
      type: [Number, String],
      default: null
    },
    task_id: {
      type: [Number, String],
      default: null
    },
    proposal: {
      type: Object,
      default: () => ({})
    },
    refresh_list: {
      type: Function,
      default: () => {}
    },
    is_charge_po: {
      type: Boolean,
      default: false
    },
    working_file_id: {
      type: Number,
      default: null
    },
    is_pop_up: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jodit_config: {
        enter: 'br',
        spellcheck: true,
        cleanHTML: {
          fillEmptyParagraph: false
        }
      },
      selected_tab: 'details',
      purchase_order: {
        id: 0,
        supplier_id: '',
        proposal_id: '',
        branch_id: '',
        sign_id: '',
        po_status_id: 1,
        is_open_quote: false,
        is_manual: 1,
        description: '',
        actual_value: 0,
        estimated_value: 0,
        charge_percent_applied: 0,
        mark_as_deleted: 0,
        category_supplier_id: 1, // as default
        contact_name: ''
      },
      message_references: [],
      po_approved_date: '',
      po_received_date: '',
      po_primary_disabled: false,
      suppliers_list: [],
      category_tasks_list: [],
      errors: [],
      po_transactions: [],
      accounts_list: [],
      categories_list: [],
      stock_items_list: [],
      quotes_list: [],
      branches_list: [],
      signs_list: [],
      is_approved: false,
      is_pending: false,
      is_open_quote: false,
      total_amount: 0,
      po_status_list: [],
      selected_stock_item: '',
      selected_supplier: '',
      selected_accounts_id: '',
      allocated_price_desc: '',
      stock_price_desc: '',
      stock_on_hand_desc: '',
      convertable_to_stock: false,
      stock_item_id: ''
    };
  },
  computed: {
    mail_count() {
      return `Mails (${this.message_references.length})`;
    },
    charge_po_sale_price() {
      let sale_price = parseFloat(this.purchase_order.actual_value);
      if (this.purchase_order.charge_percent_applied != null) {
        sale_price += (sale_price * this.purchase_order.charge_percent_applied) / 100;
      }
      return sale_price;
    },
  },
  watch: {
    po_id: function () {
      this.clear_inputs();
      this.fill_data();
      this.preload_proposal();
    }
  },
  mounted() {
    let _this = this;
    setTimeout(function () {
      _this.set_default_input();
      _this.preload_proposal();
    }, 200);
  },
  created() {
    this.fill_data();
  },
  methods: {
    open_pdf() {
      window.open(`/download_po_pdf/${this.po_id }`, '_blank');
    },
    handle_estimated_value(value) {
      this.purchase_order.estimated_value = value;
    },
    get_stock(){
      if(this.purchase_order.supplier_id && this.purchase_order.category_supplier_id && this.purchase_order.branch_id ) {
        this.$nextTick(() => {
          if (this.$refs.ref_po_stock_items) {
            this.$refs.ref_po_stock_items.get_stock_items();
          }
        });
      }
    },
    stock_item_link() {
      window.open(`/stock_items/${this.stock_item_id}/edit`, '_blank');
    },
    set_default_input() {
      Array.from(document.querySelectorAll('.el-input__inner')).forEach(
        function (e) {
          e.classList.add('browser-default');
          if (e.querySelector('input') != null)
            e.querySelector('input').className += ' browser-default';
        }
      );
    },
    update_po_approved_date() {
      let approved_po = this.po_transactions.filter(
        (item) => item.po_status == 'APPROVED'
      )[0];
      this.update_po_trans_date(approved_po.id, this.po_approved_date);
    },
    update_po_received_date() {
      let received_po = this.po_transactions.filter(
        (item) => item.po_status == 'RECEIVED'
      )[0];
      this.update_po_trans_date(received_po.id, this.po_received_date);
    },
    update_po_trans_date(id, val) {
      // let approved_po = self.po_transactions.filter(
      //   item => item.po_status == "APPROVED"
      // )[0];
      let data = {
        po_trans_id: id,
        po_date: val,
      };
      this.$http.post('/update_po_trans_date', data).then(
        () => {
          this.$message({
            message: 'PO transaction date has been updated successfully.',
            type: 'success',
          });
        },
        () => {
          this.$message({
            message:
                  'Error happened while update the record, please refresh the page an try again.',
            type: 'error',
          });
        }
      );
    },
    clear_product_inputs() {
      if (this.purchase_order.is_open_quote == true) {
        this.selected_stock_item = '';
        this.purchase_order.proposal_id = '';
        this.purchase_order.sign_id = '';
        this.purchase_order.stock_item_branch_id = '';

        this.stock_price_desc = '';
        this.stock_on_hand_desc = '';
        this.allocated_price_desc = '';
      }
    },
    is_status(status) {
      let po_status = this.po_status_list.filter(
        (item) => item.id == this.purchase_order.po_status_id
      )[0];

      return po_status.name == status;
    },
    submit_form() {
      this.$refs['purchase_order'].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    save() {
      this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.$refs['save_btn'].disabled = true;
      this.errors = [];
      let url = '/purchase_orders/';
      let request_type = 'post';
      if (this.purchase_order.id > 0) {
        request_type = 'patch';
        url = url + this.purchase_order.id;
      }
      if (this.working_file_id != undefined) {
        this.purchase_order.working_file_id = this.working_file_id;
      }

      const payload = { ...this.purchase_order };

      if (this.task_id) {
        payload.task_id = this.task_id;
      }

      this.$http[request_type](url, JSON.stringify(payload)).then(
        (response) => {
          this.$loading().close();
          this.$refs['save_btn'].disabled = false;

          this.$message({
            message: 'PO has been saved successfully.',
            type: 'success',
          });
          const redirectTo = response?.data?.redirect_to;

          if (self.is_pop_up === true) {
            self.refresh_list();
          } else if (redirectTo) {
            // when job task on job list assigned to po subcontractor, redirect to job view
            window.open(redirectTo, '_blank', 'noopener,noreferrer'); // new tab/window
            window.location = `/purchase_orders/${response.data.purchase_order_id}/edit_new`;
          } else {
            window.location = `/purchase_orders/${response.data.purchase_order_id}/edit_new`;
          }
          // if (this.is_pop_up == true) {
          //   this.refresh_list();
          // } else {
          //   // this.po_id = response.data.purchase_order_id;
          //   window.location = `/purchase_orders/${response.data.purchase_order_id}/edit_new`;
          //
          // }
        },
        (response) => {
          this.$loading().close();
          this.$refs['save_btn'].disabled = false;
          if (
            response.data.errors != undefined &&
                response.data.errors.length > 0
          ) {
            this.errors = response.data.errors;
            if (this.is_charge_po != true)
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
              });
          }
        }
      );
    },
    round(num) {
      return +(Math.round(num + 'e+3') + 'e-3');
    },
    update_actual_value() {
      this.purchase_order.actual_value = this.purchase_order.estimated_value;
    },
    stock_specs(stock) {
      return `Width: ${stock.width} , Height: ${stock.height}, GSM: ${stock.thickness}`;
    },
    actual_value_disabled() {
      let po_status = this.po_status_list.filter(
        (item) => item.id == this.purchase_order.po_status_id
      )[0];
      if (po_status == undefined) return;

      this.convertable_to_stock =
          ['RECEIVED', 'INVOICED', 'PAID'].includes(po_status) &&
          this.purchase_order.is_open_quote == true &&
          this.purchase_order.stock_item_branch_id == undefined;
      this.is_approved = po_status == 'APPROVED' ? true : false;
      this.is_pending = po_status == 'PENDING' ? true : false;

      return (
        po_status.name == 'APPROVED' ||
          po_status.name == 'RECEIVED' ||
          po_status.name == 'INVOICED' ||
          (po_status.name == 'REJECTED' && this.purchase_order.errors.length == 0)
      );
    },
    fill_email() {
      let selected_supplier = this.suppliers_list.filter(
        (item) => item.id == this.purchase_order.supplier_id
      )[0];
      if (selected_supplier != undefined) {
        this.purchase_order.send_to = selected_supplier.email;
      }
    },
    fill_lookup() {
      this.fill_po_account();
      this.fill_category_tasks();
      this.fill_suppliers();
      this.fill_categories();
      this.fill_po_statuses();
      this.load_po_quote();
      this.load_po_sign();
      this.load_branches();
      this.get_stock();
    },
    load_branches() {
      this.$http.get('/branches_list').then(
        function (response) {
          if (response.status == 200) {
            this.branches_list = response.data;
          }
        }
      );
    },
    fill_po_account() {
      if (this.purchase_order.account_id == undefined) return;
      this.$http.get('/account_by_id/' + this.purchase_order.account_id).then(
        function (response) {
          if (response.status == 200) {
            this.accounts_list = response.data;
          }
        }
      );
    },
    fill_data() {
      if (this.po_id == 0) {
        this.fill_lookup();
        return;
      }

      this.$http.get('/purchase_orders/' + this.po_id + '/edit/').then(
        (response) => {
          if (response.status == 200) {
            this.stock_item_id = response.data.stock_item_id;
            this.purchase_order = response.data.purchase_order;
            this.po_transactions = response.data.po_transactions;
            this.message_references = response.data.message_references;

            this.po_approved_date = '';
            this.po_received_date = '';

            let approved_po = this.po_transactions.filter(
              (item) => item.po_status == 'APPROVED'
            )[0];

            let received_po = this.po_transactions.filter(
              (item) => item.po_status == 'RECEIVED'
            )[0];

            if (approved_po != undefined)
              this.po_approved_date = approved_po.created_at;
            else this.po_approved_date = '';

            if (received_po != undefined)
              this.po_received_date = received_po.created_at;

            this.purchase_order.is_open_quote =
                  this.purchase_order.is_open_quote == 1 ? true : false;
            if (this.purchase_order.po_status_id > 1)
              this.po_primary_disabled = true;

            this.fill_lookup();
          }
          this.get_stock();
        },
        function (response) {
          console.log(response);
        }
      );
    },
    fill_category_tasks() {
      this.$http.get('/category_tasks_list').then(
        function (response) {
          // Success
          if (response.status == 200) {
            this.category_tasks_list = response.data;
          }
        },
        function (response) {
          // error
          console.log(response);
        }
      );
    },
    fill_suppliers() {
      let query_str = '';
      // if(this.purchase_order.supplier_id != undefined)
      //     query_str = "?id=" + this.purchase_order.supplier_id
      this.$http.get('/suppliers_list' + query_str).then(
        function (response) {
          // Success
          if (response.status == 200) {
            this.suppliers_list = response.data;
          }
        },
        function (response) {
          // error
          console.log(response);
        }
      );
    },
    fill_categories() {
      this.$http.get('/category_suppliers_list').then(
        function (response) {
          if (response.status == 200) {
            this.categories_list = response.data;
          }
        },
        function (response) {
          // error
          console.log(response);
        }
      );
    },
    accounts_list_query(term) {
      let encoded_term = encodeURIComponent(term);
      this.$http.get('/accounts_with_proposals?term=' + encoded_term).then(
        function (response) {
          this.accounts_list = response.data;
        }
      );
    },
    fill_po_statuses() {
      this.$http.get('/po_statuses_by_id/' + (this.purchase_order.po_status_id || 1))
        .then(
          async function (response) {
            this.po_status_list = await response.data;
          },
          function (response) {
            console.log(response);
          }
        );
    },
    load_po_quote() {
      if (this.is_charge_po == true) {
        this.purchase_order.is_open_quote = true;
      }

      if (
        this.purchase_order.proposal_id == undefined ||
          this.purchase_order.proposal_id == '' ||
          this.purchase_order.proposal_id == null
      )
        return;
      let prop_id = this.purchase_order.proposal_id;
      this.$http.get('/proposals_list/' + prop_id).then(
        function (response) {
          if (response.status == 200) {
            this.quotes_list = response.data;
          }
        },
        function (response) {
          // error
          console.log(response);
        }
      );
    },
    load_po_sign() {
      if (this.purchase_order.sign_id == undefined) return;
      this.$http.get('/signs/' + this.purchase_order.sign_id).then(
        function (response) {
          if (response.status == 200) {
            this.signs_list = [response.data];
          }
        }
      );
    },
    refetch_quotes() {
      if (this.selected_accounts_id != undefined)
        this.load_quotes_by_account_id(this.selected_accounts_id);
    },
    load_quotes_by_account_id(id) {
      this.quotes_list = [];
      this.purchase_order.proposal_id = '';
      let filter = '';

      if (this.purchase_order.category_task_id != undefined)
        filter = '&category_task_id=' + this.purchase_order.category_task_id;
      this.$http
        .get('/get_proposals_by_account?account_id=' + (id || 0) + filter)
        .then(
          function (response) {
            // Success
            if (response.status == 200) {
              this.quotes_list = response.data;
            }
          },
          function (response) {
            // error
            console.log(response);
          }
        );
    },
    load_signs_by_proposal_id(id) {
      this.signs_list = [];
      this.purchase_order.sign_id = '';
      this.$http.get('/get_signage_by_proposal?proposal_id=' + (id || 0)).then(
        function (response) {
          // Success
          if (response.status == 200) {
            this.signs_list = response.data;
          }
        },
        function (response) {
          // error
          console.log(response);
        }
      );
    },
    clear_inputs() {
      this.purchase_order = {
        id: 0,
        supplier_id: '',
        proposal_id: '',
        sign_id: '',
        po_status_id: 1,
        is_open_quote: false,
        is_manual: 1,
        description: '',
        actual_value: 0,
        estimated_value: 0,
        category_task_id: '',
      };
      this.po_transactions = [];
    },
    preload_proposal() {
      if (
        this.is_pop_up == true &&
          this.proposal &&
          this.proposal.id != undefined
      ) {
        this.purchase_order.branch_id = this.proposal.branch_id;
        this.selected_accounts_id = this.proposal.account_id;
        this.quotes_list = [
          {id: this.proposal.id, value: this.proposal.job_name},
        ];
        this.accounts_list = [
          {
            id: this.selected_accounts_id,
            account_name: this.proposal.account_name,
          },
        ];
        this.purchase_order.proposal_id = this.proposal.id;

      }
    },
  },
};
</script>

<style>
.status-line{
  display: flex;
  align-items: center;
  gap: 12px;
  float: right;
}
.row-3 {
  display: flex;
  gap: 12px;
  margin-left: 10px;
  margin-right: 10px;
}
.row-3 .field {
  flex: 1;
}

.row-2 {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3-column sizing */
  gap: 12px;
  margin-left: 10px;
  margin-right: 10px;
}

.row-2 .field {
  width: 100%;
}
.step-header {
  display:flex;
  justify-content:space-between;
  width:100%;
  margin-left: 10px;
  padding-right: 30px;
}

#po-form .el-form--label-top .el-form-item__label{
  padding:0px;
}
#po-form .el-form-item__label{
  line-height: 0px;
  padding:0px;
}
#po-form .el-form-item {
  margin-bottom: 8px !important;
}

.space-textarea{ margin: 0 10px 0 10px;}
.space-headline{ margin: 20px 0px 10px 10px;}
</style>
